import { Card, CardBody, CardFooter, Skeleton } from '@heroui/react';
import { Container } from '@school-manage/ui/Container/Container';
import { HeaderBar } from '@school-manage/ui/HeaderBar/HeaderBar';
import { useTranslation } from 'react-i18next';

export function SportRecordDetailSkeleton() {
  const { t } = useTranslation();

  return (
    <>
      <HeaderBar title={t('recordDetail')} />
      <Container hasNavigationGap={false}>
        {Array.from(Array(2).keys()).map((i) => (
          <Card key={i} shadow="none">
            <CardBody>
              <Skeleton className="mb-4 h-6 w-1/4 rounded-lg" />
              <div className="grid grid-cols-1 gap-4">
                <Card>
                  <CardBody className="flex items-center justify-center gap-y-2 text-center">
                    <Skeleton className="h-6 w-2/3 rounded-lg" />
                    <Skeleton className="h-4 w-1/3 rounded-lg" />
                  </CardBody>
                </Card>
                <Card>
                  <CardBody className="flex items-center justify-center gap-y-2 text-center">
                    <Skeleton className="h-6 w-2/3 rounded-lg" />
                    <Skeleton className="h-4 w-1/3 rounded-lg" />
                  </CardBody>
                </Card>
              </div>
            </CardBody>
          </Card>
        ))}

        <Card shadow="none">
          <CardBody>
            <Skeleton className="mb-4 h-6 w-1/4 rounded-lg" />
            <div className="grid grid-cols-2 gap-4">
              <div className="flex flex-col items-center justify-center gap-y-2 text-center">
                <Skeleton className="size-12 rounded-lg" />
                <Skeleton className="h-4 w-2/3 rounded-lg" />
                <Skeleton className="h-4 w-2/3 rounded-lg" />
              </div>
              <div className="flex flex-col items-center justify-center gap-y-2 text-center">
                <Skeleton className="size-12 rounded-lg" />
                <Skeleton className="h-4 w-2/3 rounded-lg" />
                <Skeleton className="h-4 w-2/3 rounded-lg" />
              </div>
            </div>
          </CardBody>
        </Card>

        <Card shadow="none">
          <CardBody>
            <Skeleton className="mb-4 h-6 w-1/4 rounded-lg" />
            <Skeleton className="aspect-video w-full rounded-lg" />
          </CardBody>
        </Card>

        <Card shadow="none">
          <CardBody className="flex flex-col gap-4">
            <Skeleton className="mb-4 h-6 w-1/4 rounded-lg" />
            <Skeleton className="mx-auto flex size-[64px] items-center justify-center rounded-full p-[4px] text-[32px]" />
            <div className="flex flex-col gap-y-2">
              <Skeleton className="h-4 w-2/12 rounded-lg" />
              <Skeleton className="h-4 w-full rounded-lg" />
              <Skeleton className="h-4 w-full rounded-lg" />
              <Skeleton className="h-4 w-2/3 rounded-lg" />
            </div>
          </CardBody>
          <CardFooter className="flex items-center justify-between gap-x-4">
            <Skeleton className="h-4 w-1/3 rounded-lg" />
            <Skeleton className="h-4 w-1/3 rounded-lg" />
          </CardFooter>
        </Card>
      </Container>
    </>
  );
}
